// filepath: /home/toofoocustomer/tf-node/tf_customer_web/lib/customer/global-profile-options.ts

export const ISO_REGION_CODES = ["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"] as const;

export type IsoRegionCode = (typeof ISO_REGION_CODES)[number];

export const SUPPORTED_CUSTOMER_LOCALES = [
  { code: "ko-KR", label: "한국어" },
  { code: "en-US", label: "English" },
] as const;

export function regionFromLocale(locale: string | null | undefined): string {
  const normalized = (locale ?? "").trim();
  const parts = normalized.split("-");
  for (const part of parts.slice(1)) {
    const candidate = part.toUpperCase();
    if (/^[A-Z]{2}$/.test(candidate) && (ISO_REGION_CODES as readonly string[]).includes(candidate)) {
      return candidate;
    }
  }
  return "";
}

export function browserPreferredLocale(): string {
  if (typeof navigator === "undefined") return "en-US";
  const value = navigator.language?.trim().toLowerCase() ?? "";
  return value.startsWith("ko") ? "ko-KR" : "en-US";
}

export function regionDisplayName(regionCode: string, locale: string): string {
  try {
    const displayNames = new Intl.DisplayNames([locale || "en-US"], { type: "region" });
    return displayNames.of(regionCode) || regionCode;
  } catch {
    return regionCode;
  }
}
